import {Component, Input, Output, OnInit, ViewChild, ElementRef, HostListener, EventEmitter} from '@angular/core';
import {GameSetUpService} from '../../providers/gameSetUp.service';
import {LastGamesService} from '../../providers/lastGames.service';



@Component({
    selector: 'last-games-component',
    templateUrl: './last-games.component.html',
    styleUrls: ['./last-games.component.scss']
})
export class LastGamesComponent implements OnInit {


    @Output() onSelect = new EventEmitter();
    public lastGames: any = [];


    constructor(public lastGamesService: LastGamesService, public gameSetUpService: GameSetUpService) {
    }

    ngOnInit() {
        this.loadGameSetUps();
        console.log('lastGames', this.lastGames);
    }


    loadGameSetUps() {
        this.lastGames = this.lastGamesService.loadGameSetUps();
    }


    getLastGames() {
        if (this.gameSetUpService.gameMode === 'X01') {
            return this.lastGames.x01;
        }
        if (this.gameSetUpService.gameMode === 'count-up') {
            return this.lastGames.countUp;
        }
    }

    onClick(i) {

        if (this.gameSetUpService.gameMode === 'X01') {
            this.gameSetUpService.setGameBySetUpData(this.lastGames.x01[i]);
        }
        if (this.gameSetUpService.gameMode === 'count-up') {
            this.gameSetUpService.setGameBySetUpData(this.lastGames.countUp[i]);
        }

    }


}



// WEBPACK FOOTER //
// ./src/app/components/last-games/last-games.component.ts